import {
  ActionIcon,
  Button,
  Divider,
  Flex,
  Group,
  Paper,
  Stack,
  Text,
  Textarea,
} from "@mantine/core";
import { IconArrowLeft, IconCheck, IconTrash } from "@tabler/icons-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { deleteBounces } from "../../../../../api/AdminAPI";
import { notifications } from "@mantine/notifications";

const DeleteBounces = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    const emails = data.emails.trim().split("\n");
    deleteBounces({ emails })
      .then((r) => {
        notifications.show({
          color: "green",
          message: "Bounces supprimés avec succès",
        });
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack flex={1} pr={48} pt={16} gap={0}>
      <Group gap={"md"}>
        <ActionIcon size={"xl"} component={Link} to={"/settings/tools"}>
          <IconArrowLeft />
        </ActionIcon>
        <Text size="xl" fw={600} mr={"auto"}>
          Supprimer des emails en bounces (super_admin only)
        </Text>
      </Group>

      <Divider my={16} />

      <Paper p={"lg"} component="form" onSubmit={handleSubmit}>
        <Text size="lg" mb={16}>
          1 email par ligne
        </Text>
        <Textarea
          size="lg"
          name="emails"
          label="Emails à supprimer"
          placeholder="1 email par ligne"
          required
          rows={10}
        />
        {success ? (
          <Button
            size="md"
            mt={16}
            leftSection={<IconCheck />}
            color="green"
            w={300}
          >
            Supprimé du serveur
          </Button>
        ) : (
          <Button
            type="submit"
            size="md"
            mt={16}
            loading={loading}
            color="red"
            leftSection={<IconTrash />}
            w={300}
          >
            Supprimer ces emails du serveur
          </Button>
        )}

        <Text c={"red"} fw={600} mt={16}>
          Attention cette action est irréversible !
        </Text>
      </Paper>
    </Stack>
  );
};

export default DeleteBounces;
